export const assetJsonData = {
  "form31": [{
      label: "1）擁有土地 / 房產(非住宅用途)資產 (請填寫類別) <br>   I am land / property(non-residential) owner (please fill in the type)*",
      key: "field31_1",
      leftSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "select",
      options: "land_property",
      rightSpan: 8,
      isMoney: false
    },

    {
      label: "2）類別<br>Type*",
      key: "field31_2",
      leftSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "select",
      options: "land_type",
      rightSpan: 16,
      isMoney: false
    },
    {
      label: "3）地址<br> Address*",
      key: "field31_3",
      leftSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 16,
      isMoney: false
    },

    {
      label: "4）面積 (平方呎)<br>Area (square feet) *",
      key: "field31_4",
      leftSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 16,
      isMoney: false
    },
    {
      label: "5）我所佔權益百份比<br>Percentage of interest owned by me*",
      key: "field31_5",
      leftSpan: 8,
      midSpan: 0,
      needUnit: true,
      needNumber: true,
      unit: "%",
      type: "input",
      rightSpan: 16,
      isMoney: false
    },
    {
      label: "6）其他人士 / 公司 所佔的百份比<br>Percentage of interest owned by others*",
      key: "field31_6",
      leftSpan: 8,
      midSpan: 0,
      needUnit: true,
      needNumber: true,
      unit: "%",
      type: "input",
      rightSpan: 16,
      isMoney: false
    },
    {
      label: " 7）在申請日，我於該土地／房產(非住宅用途)所佔的資產淨值<br>As at the application date, the net asset value I own in the land / property(non-residential) *",
      key: "field31_7",
      leftSpan: 18,
      rightSpan: 6,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "8）該土地／房產(非住宅用途)的使用情況<br>The use of the land/property(non-residential) *",
      key: "field31_8",
      leftSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "select",
      options: "use_of_land",
      rightSpan: 8,
      isMoney: false
    },
    {
      label: "9）如有出租情況, 請填寫出租月數 ( 以申請日前最多 6 個曆月為限)<br>For letting out situation, please fill in number of rental months (max 6 months before application date) *",
      key: "field31_9",
      leftSpan: 18,
      midSpan: 0,
      needUnit: true,
      unit: "月",
      type: "input",
      rightSpan: 6,
      isMoney: false
    },
    {
      label: "10（A）如有出租情況，請填寫合共租金（每月租金 x 上述出租月數）<br>For letting out situation, please fill in the total rent received (monthly rent x the number of months rented out) *",
      key: "field31_10",
      leftSpan: 18,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 6,
      isMoney: true
    },
    {
      label: "11（B）如有出租情況，請填寫合共支出（每月支出 x 上述出租月數）<br>For letting out situation, please fill in the total expenditure (monthly expenditure x the number of months rented out) *",
      key: "field31_11",
      leftSpan: 18,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 6,
      isMoney: true
    },
    {
      label: "12（C）合共淨租金（A ）- （B）<br>Total Net Rental (A)- (B) *",
      key: "field31_12",
      leftSpan: 18,
      midSpan: 0,
      needUnit: false,
      readOnly: true,
      type: "input",
      rightSpan: 6,
      isMoney: true
    },
    {
      label: "13）如有空置情況 （包括自用）， 請填寫空置月數(以申 請日前最多 6 個曆月為限),<br>For vacant situation (including self-use), please fill in the number of vacant months (max. 6 calendar months before application date) *",
      key: "field31_13",
      leftSpan: 18,
      midSpan: 0,
      needUnit: true,
      unit: "月",
      type: "input",
      rightSpan: 6,
      isMoney: false
    },
    {
      label: "14（D）如有空置情況 （包括自用），請填寫合共租金 （每月租金 x 上述空置月數）<br>For vacant situation (including self-use), please fill in the total rent received (monthly rent x  number of vacant months) *",
      key: "field31_14",
      leftSpan: 18,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 6,
      isMoney: true
    },
    {
      label: "15（E）如有空置情況 （包括自用），請填寫合共支出 （每月支出 x 上述空置月數)<br>For vacant situation (including self-use), please fill in the total expenditure (monthly expenditure x the number of vacant months) *",
      key: "field31_15",
      leftSpan: 18,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 6,
      isMoney: true
    },
    {
      label: "16）（F）合共淨租金（D）- （E）<br>Total Net Rental (D)- (E) *",
      key: "field31_16",
      leftSpan: 18,
      midSpan: 0,
      needUnit: false,
      type: "input",
      readOnly: true,
      rightSpan: 6,
      isMoney: true
    },
    {
      label: "17）該土地／房產(非住宅用途)的每月平均淨租金 [（C） + （F）÷ 6 個曆月]<br>The average monthly net rental of the property(non-residential) [(C)+(F)÷6] *",
      key: "field31_17",
      leftSpan: 18,
      midSpan: 0,
      needUnit: false,
      readOnly: true,
      type: "input",
      rightSpan: 6,
      isMoney: true
    },
    {
      label: "18）我於該土地／房產(非住宅用途)所佔的每月平均淨租金<br>My average monthly share on net rental for the property(non-residential) *",
      key: "field31_18",
      leftSpan: 18,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 6,
      isMoney: true
    },
    {
      label: "19）資料或文件描述補充 (如有) <br> Add information and File Description (if any)",
      key: "field31_19",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },
    {
      label: "",
      key: "uploadFiles",
      fileLabel: "持有土地/房產(非住宅用途)",
      type: "upload",
      uploadDesc: "須遞交土地/房產最近期估值報告、持有人證明文件、相關按揭的證明文件、最近期的差餉及地租繳費通知書<br>Please provide the copy of the most recent Valuation Report of the land/real estate, Certificate of the land / real estate holder, Relevant Mortgage Loan Certificate and Demands for Rates and/or Government Rent",
    }
  ],
  "form32": [{
      label: "1）在申請日時該車輛淨值資產 <br> The vehicle net asset value as at application date*",
      key: "field32_1",
      leftSpan: 18,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 6,
      isMoney: true
    },
    {
      label: "2）資料或文件描述補充 (如有) <br> Add information and File Description (if any)",
      key: "field32_2",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },
    {
      label: "",
      key: "uploadFiles",
      fileLabel: "持有車輛",
      type: "upload",
      uploadDesc: "須上傳牌照副本<br>Please provide the copy of vehicle licence",
    }
  ],
  "form33": [{
      label: "1）車輛登記編號 <br> The registration number of my owned taxi/public light bus*",
      key: "field33_1",
      leftSpan: 12,
      midSpan: 0,
      needUnit: false,
      type: "input",
      rightSpan: 12,
      isMoney: false
    },

    {
      label: "2）的士 / 公共小型巴士牌照(連車輛)淨資產。 (在申請日時 牌照公開市塲成交價加車輛購入價(如未包括在牌照內)減 在申請日未償還分期付款額及車輛折舊)  <br>   Net value of the license: Open market transaction price as at application date + vehicle purchase price ( if not included in the license value) - outstanding Hire Purchase Repayment as at the application date - depreciation. *",
      key: "field33_2",
      leftSpan: 16,
      rightSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "3）資料或文件描述補充 (如有) <br> Add information and File Description (if any)",
      key: "field33_3",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    },
    {
      label: "",
      key: "uploadFiles",
      fileLabel: "持有的士/公共小型巴士牌照",
      type: "upload",
      uploadDesc: "須上傳牌照副本、相關分期付款合約副本及牌照的最近期估值報告<br>Please provide the copy of commercial vehicle (taxi/public light bus) licence, hire Purchase Agreement and valuation report for commercial vehicle license",
    }
  ],
  "form34": [{
      label: "1）投資產品在申請日之最近期資產淨值或最近期的單位收市價計算其價值（包括儲蓄或投資保險計劃、股票、債券、期貨、紙黃金、存款證、經紀投資按金、互惠基金及單位信託基金等）<br> Net Asset Value of investment product as at application date. Investment products include stocks, bonds, futures, paper gold, certificates of deposit, brokerage investment deposits, mutual funds and unit trust funds, etc*",
      key: "field34_1",
      leftSpan: 16,
      rightSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "2）在過去 12 個曆月收取利息/股息或紅利 <br> The average interest / bonus / dividend received in the past 12 calendar months*",
      key: "field34_2",
      leftSpan: 16,
      rightSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "3）資料或文件描述補充 (如有) <br> Add information and File Description (if any)",
      key: "field34_3",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    }
  ],
  "form35": [{
      label: "1）公司資產淨值為港幣 (根據公司最近期已經核實財政報告 / 營業損益表計算) <br> Net asset value of the company (based on the most updated audited report / financial report) *",
      key: "field35_1",
      leftSpan: 16,
      rightSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "2）資料或文件描述補充 (如有) <br> Add information and File Description (if any)",
      key: "field35_2",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    }
  ],
  "form36": [{
      label: "1）定期存款金額及所有儲蓄及 / 或往來帳戶結餘(如有) <br>Amount of fixed deposit held and Balance of all saving / current account(if any)",
      key: "field36_1",
      leftSpan: 16,
      rightSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "2）手頭可動用現金 (如有) <br> Cash on hand (if any)",
      key: "field36_2",
      leftSpan: 16,
      rightSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "3）貸款（借出的總金額）(如有) <br> Amount of loan to others(if any)",
      key: "field36_3",
      leftSpan: 16,
      rightSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "4）在過去 12 個曆月每月平均獲取利息 (如有) <br> The average monthly interest earned in the past 12 months(if any)",
      key: "field36_4",
      leftSpan: 16,
      rightSpan: 8,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: true
    },
    {
      label: "5）資料或文件描述補充 (如有) <br> Add information and File Description (if any)",
      key: "field36_5",
      leftSpan: 8,
      rightSpan: 16,
      midSpan: 0,
      needUnit: false,
      type: "input",
      isMoney: false
    }
  ]
}



// WEBPACK FOOTER //
// ./src/utils/json/assetFormField.js